import * as React from "react";
import type { SVGProps } from "react";
const SvgConsolidate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M12.007 1.75H2.01a.25.25 0 0 0-.25.25v9.996c0 .138.112.25.25.25h9.997a.25.25 0 0 0 .25-.25V1.999a.25.25 0 0 0-.25-.25ZM2.01 0a2 2 0 0 0-2 2v9.996a2 2 0 0 0 2 1.999h9.997a2 2 0 0 0 1.999-2V2a2 2 0 0 0-2-1.999H2.01ZM28.668 1.75H18.67a.25.25 0 0 0-.25.25v9.996c0 .138.112.25.25.25h9.997a.25.25 0 0 0 .25-.25V1.999a.25.25 0 0 0-.25-.25ZM18.67 0a2 2 0 0 0-2 2v9.996a2 2 0 0 0 2 1.999h9.997a2 2 0 0 0 1.999-2V2a2 2 0 0 0-2-1.999h-9.996ZM45.328 1.75H35.33a.25.25 0 0 0-.25.25v9.996c0 .138.112.25.25.25h9.997a.25.25 0 0 0 .25-.25V1.999a.25.25 0 0 0-.25-.25ZM35.33 0a2 2 0 0 0-1.999 2v9.996a2 2 0 0 0 2 1.999h9.996a2 2 0 0 0 2-2V2a2 2 0 0 0-2-1.999H35.33ZM61.989 1.75h-9.996a.25.25 0 0 0-.25.25v9.996c0 .138.111.25.25.25h9.996a.25.25 0 0 0 .25-.25V1.999a.25.25 0 0 0-.25-.25ZM51.993 0a2 2 0 0 0-2 2v9.996a2 2 0 0 0 2 1.999h9.996a2 2 0 0 0 2-2V2a2 2 0 0 0-2-1.999h-9.996ZM32.438 18.119c.483 0 .874.391.874.874v11.132a.875.875 0 1 1-1.749 0V18.993c0-.483.392-.874.875-.874Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M38.352 26.713c.28.394.186.94-.208 1.22L33.1 31.51a1.374 1.374 0 0 1-1.634-.031l-4.64-3.568a.875.875 0 1 1 1.067-1.386l4.42 3.398 4.82-3.418a.875.875 0 0 1 1.219.207Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M18.504 38.01a2 2 0 0 1 2-2h23.991a2 2 0 0 1 2 2V62a2 2 0 0 1-2 2H20.504a2 2 0 0 1-2-2V38.01Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M44.495 37.76H20.504a.25.25 0 0 0-.25.25V62c0 .139.112.25.25.25h23.991a.25.25 0 0 0 .25-.25V38.01a.25.25 0 0 0-.25-.25Zm-23.991-1.75a2 2 0 0 0-2 2V62a2 2 0 0 0 2 2h23.991a2 2 0 0 0 2-2V38.01a2 2 0 0 0-2-2H20.504Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32.5 36.38c.482 0 .874.392.874.875v25.336a.875.875 0 0 1-1.75 0V37.255c0-.483.392-.874.875-.874Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M18.953 50.005c0-.483.392-.875.875-.875h25.267a.875.875 0 1 1 0 1.75H19.828a.875.875 0 0 1-.875-.875Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgConsolidate;
